"use strict";

exports.__esModule = true;
exports.getCommonSampleDataItems = void 0;
var _getDeviceDataItems = require("../../../Device/common/getDeviceDataItems");
var _constants = require("../../../constants");
var getCommonSampleDataItems = exports.getCommonSampleDataItems = function getCommonSampleDataItems(devices) {
  if (!Array.isArray(devices)) {
    return [];
  }
  return devices.reduce(function (commonDataItems, device) {
    if (commonDataItems.length === 0) return [];
    return commonDataItems.filter(function (commonDataItem) {
      return (0, _getDeviceDataItems.getDeviceDataItems)(device).find(function (deviceDataItem) {
        return deviceDataItem.name === commonDataItem.name && commonDataItem.category === _constants.CATEGORY_SAMPLE;
      }) !== undefined;
    });
  }, (0, _getDeviceDataItems.getDeviceDataItems)(devices[0]));
};